import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  Image,
  Row,
  Dropdown,
  ListGroup,
  InputGroup,
  Form,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { IMAGES } from "../../constants/images";
import CategoriesComponent from "../../components/CategoriesComponent";
import ArrowIcon from "../../components/ArrowIcon";
import TestimonialSlider from "../../components/TestimonialSlider";
import AccordionComponent from "../../components/AccordionComponent";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import Modals from "inc/Modals";
import { useAuth } from "context/UserContext";
import { useUserRole } from "services/provider";
import { searchHome } from "api/ActivityService";
import AccordionComponentHome from "components/AccordionComponentHome";

const categories = [
  {
    name: "Project Management",
    icon: <Icon fontSize={20} icon="hugeicons:trade-up" />,
  },
  { name: "CRM Tools", icon: <Icon fontSize={20} icon="hugeicons:trade-up" /> },
  {
    name: "E-Commerce Platforms",
    icon: <Icon fontSize={20} icon="hugeicons:trade-up" />,
  },
  {
    name: "Online Backup",
    icon: <Icon fontSize={20} icon="hugeicons:trade-up" />,
  },
  {
    name: "AI Chatbots",
    icon: <Icon fontSize={20} icon="hugeicons:trade-up" />,
  },
];

const products = [
  { name: "monday Work Management", icon: "📊" },
  { name: "Smartsheet", icon: "📋" },
  { name: "Notion", icon: "📝" },
  { name: "Slack", icon: "💬" },
  { name: "Project Management", icon: "📂" },
];

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, user } = useAuth();
  const [modalType, setModalType] = useState("");
  const { role, setRole } = useUserRole();
  // Search
  const [searchTerm, setSearchTerm] = useState("");
  const filteredCategories = categories.filter((cat) =>
    cat.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredProducts = products.filter((prod) =>
    prod.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [searchResults, setSearchResults] = useState({
    software: [],
    solutions: [],
    products: [],
  });
  const [searchLoading, setSearchLoading] = useState(false);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim()) {
        fetchSearchResults();
      } else {
        setSearchResults({ software: [], solutions: [], products: [] });
      }
    }, 300); // debounce

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fetchSearchResults = async () => {
    try {
      setSearchLoading(true);
      const res = await searchHome(searchTerm);
      if (res.success) {
        setSearchResults(res.body);
      }
    } catch (err) {
      console.error("Search failed", err);
    } finally {
      setSearchLoading(false);
    }
  };

  return (
    <React.Fragment>
      {/* Banner Section */}
      <section
        className="banner_section"
        style={{ backgroundImage: `url(${IMAGES.Banner_Img})` }}
      >
        <Container>
          <Row>
            <Col md={12}>
              <h1>Find the right software with Us!</h1>
              <p>
                We helps you discover the ideal solutions for your business.
                Compare options by price, features, business size, industry, and
                reviews from verified users.
              </p>
              <div className="search_section">
                <InputGroup className="mb-2">
                  <Form.Control
                    placeholder="Search for software, category, or solution..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <InputGroup.Text id="basic-addon2">Search</InputGroup.Text>
                </InputGroup>

                {/* Dropdown results */}
                {searchTerm && (
                  <Dropdown.Menu show>
                    {searchLoading ? (
                      <Dropdown.Item>Searching...</Dropdown.Item>
                    ) : (
                      <>
                        {searchResults.software.length > 0 && (
                          <>
                            <Dropdown.Header className="fw-bold">
                              Software
                            </Dropdown.Header>
                            <ListGroup variant="flush">
                              {searchResults.software.map((item) => (
                                <ListGroup.Item
                                  key={item._id}
                                  as={Link}
                                  to={`/software/${item.slug}`}
                                  state={{ resource: item }}
                                 
                                >
                                  🧩{" "}
                                  <span className="ms-2">
                                    {item.slug.replace(/-/g, " ")}
                                  </span>
                                </ListGroup.Item>
                              ))}
                            </ListGroup>
                          </>
                        )}

                        {searchResults.solutions.length > 0 && (
                          <>
                            <Dropdown.Header className="fw-bold mt-3">
                              Solutions
                            </Dropdown.Header>
                            <ListGroup variant="flush">
                              {searchResults.solutions.map((item) => (
                                <ListGroup.Item                
                                  key={item._id}
                                  as={Link}
                                  to={`/solutions/${item.slug}`}
                                  state={{ resource: item }}
                                >
                                  🛠{" "}
                                  <span className="ms-2">
                                    {item.slug.replace(/-/g, " ")}
                                  </span>
                                </ListGroup.Item>
                              ))}
                            </ListGroup>
                          </>
                        )}

                        {searchResults.products.length > 0 && (
                          <>
                            <Dropdown.Header className="fw-bold mt-3">
                              Products
                            </Dropdown.Header>
                            <ListGroup variant="flush">
                              {searchResults.products.map((item) => (
                                <ListGroup.Item
                                  key={item._id}
                                  action
                                  onClick={() =>
                                    navigate(`/product-details/${item.slug}`)
                                  }
                                >
                                  <img src={item.logoUrl} alt={item.name} className="img-fluid" style={{width: "20px", height: "20px"}}/>
                                  <span className="ms-2">
                                    {item.slug.replace(/-/g, " ")}
                                  </span>
                                </ListGroup.Item>
                              ))}
                            </ListGroup>
                          </>
                        )}

                        {searchResults.software.length === 0 &&
                          searchResults.solutions.length === 0 &&
                          searchResults.products.length === 0 && (
                            <Dropdown.Item>No results found</Dropdown.Item>
                          )}
                      </>
                    )}
                  </Dropdown.Menu>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Categories Section */}
      <section
        className="py80 categories_section"
        style={{ backgroundImage: `url(${IMAGES.Gradient_Img})` }}
      >
        <Container>
          <h2 className="text-center mb-4">
            The Most Widely Used Software
            <br /> Categories.
          </h2>
          <CategoriesComponent />
        </Container>
      </section>
      {/* Review Section */}
      <section className="py80 review_section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <Image
                src={IMAGES.Review_Img}
                alt="Review"
                className="img-fluid"
              />
            </Col>
            <Col lg={6}>
              <h2>
                Experience with
                <br /> Software?{" "}
                <strong>
                  Leave a <br /> Review!
                </strong>
              </h2>
              <p>
                Experience seamless coordination and personalized attention with
                our Dedicated Project Manager. From inception to execution, your
                project will be in expert hands, ensuring efficient
                communication, timely deliverables, and a tailored approach that
                meets your unique objectives.
              </p>
            {(!user || user.role === "user") && <Button
                onClick={() => {
                  navigate("/write-a-review");
                  localStorage.removeItem("step");
                  localStorage.removeItem("checkedProducts");
                  localStorage.removeItem("verificationId");
                }}
                className="border-radius-100"
                variant="info"
              >
                Write a Review <ArrowIcon color="#ffffff" />
              </Button>}
            </Col>
          </Row>
        </Container>
      </section>
      {/* Report Section */}
      <section className="py80 review_section report_section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <h2>
                Our Analysis of Buyer <br /> Behavior!
              </h2>
              <p>
                ROI, according to a 2024 Buyer Behavior Report based on a survey
                of over 1,900 B2B buyers worldwide
              </p>
              <Button className="border-radius-100" variant="info">
                Download Report <ArrowIcon color="#ffffff" />
              </Button>
            </Col>
            <Col lg={6} className="mt-4 mt-lg-0 text-center buyPos">
              <Image
                src={IMAGES.Buyer_Img}
                alt="Review"
                className="img-fluid position-relative z-1"
              />
              <Image
                src={IMAGES.BuyerTransparent_Img}
                alt="Review"
                className="img-fluid btnTransparentPos"
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Client Section */}
      <section className="py80 client_section position-relative">
        <Container className="position-relative z-1">
          <h2 className="text-center mb-5">What they Say About Us!</h2>
          <Row className="align-items-center">
            <Col lg={12} className="position-relative">
              <Image
                src={IMAGES.Clientsvg1_Img}
                alt="Review"
                className="img-fluid shapeImg1 z-0"
              />
              <TestimonialSlider />
            </Col>
          </Row>
        </Container>
        <Image
          src={IMAGES.Clientsvg2_Img}
          alt="Review"
          className="img-fluid shapeImg2 z-0"
        />
      </section>
      {/* Reach Section */}
      <section className="py80 review_section buy_section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <h2>
                Reach More Potential Buyers <br /> for Your Software.
              </h2>
              <p>
                Expand your market presence and connect with the right audience.
                Our platform helps you showcase your software to millions of
                interested buyers, ensuring greater visibility and increased
                opportunities for sales.
              </p>
              <Button
               onClick={() => {
                setModalType("login");
                setRole("vendor");
                if (isLoggedIn && user.role === "vendor") {
                  setModalType("login");
                }
              }}
                className="border-radius-100"
                variant="info"
              >
                Claim Your Profile <ArrowIcon color="#ffffff" />
              </Button>
            </Col>
            <Col lg={6} className="mt-4 mt-lg-0 text-center buyPos">
              <Image
                src={IMAGES.Reach_Img}
                alt="Review"
                className="img-fluid position-relative z-1"
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Client Section */}
      <section className="py80 client_section position-relative">
        <Container className="position-relative z-1">
          <h2 className="text-center mb-5">
            Research popular software & solutions.
          </h2>
          <AccordionComponentHome />
        </Container>
      </section>

      <Modals
        modalType={modalType}
        navigateTo={location.pathname || "/"}
        setModalType={setModalType}
        handleCloseModal={() => {
          setModalType("");
        }}
        {...{
          role: role,
          navigate,
        }}
      />
    </React.Fragment>
  );
};
export default Home;
